import _ from 'lodash';
import request, { isSalesSupport, isSalesManager } from '../utils/request';
import { getPathVariables } from '../misc';
import {
  businessConnectQuoteToolForm,
  orderStatus,
  businessConnectQuoteToolOrderCategoryName,
  quoteStatus,
  orderDetailsForm,
  fieldSubmittingOnBehalfOf
} from '../utils/constant';

export const isEligibilityForm = () => {
  const [, categoryName, formName] = getPathVariables(window.location.pathname);
  return (
    businessConnectQuoteToolOrderCategoryName === categoryName &&
    businessConnectQuoteToolForm === formName
  );
};

function submitPayload(formData, step,
  isMultisiteOrder,
  currentSite,
  totalNumberOfMultisites,
  orderData,
  orderStatusValue,
  steps) {
  const userProfile = request.getProfile();
  const { name, email } = userProfile;
  const salesRepInfoForSRT = JSON.parse(
    localStorage.getItem('salesRepInfoForSRT')
  );
  const [, , formName] = getPathVariables(window.location.pathname);
  let payload = { ...formData };

  // SOF-3356 T027 — Sales Manager identity injection for downstream documents.
  // When the submitter is a Sales Manager, attach `salesManagerName` so the
  // backend (T028) can substitute it into Wireline / CS / BCx / IoT quote PDFs,
  // contract PDFs, and confirmation emails. For Business Connect specifically,
  // also attach `salesManagerCpmsId` (sourced from the SM's `salesRepId`, the
  // SOF1 wire field for `cpms_id`) so the BCx Sales Rep ID slot is populated.
  // Business Apps suppression (FR-017, B-8) is enforced backend-side (T029);
  // it is safe and required to send these fields for all SM submissions here.
  if (isSalesManager) {
    const smProfile = request.getProfile() || {};
    payload.salesManagerName = `${_.get(smProfile, 'firstName', '')} ${_.get(smProfile, 'lastName', '')}`.trim();
    if (formName === businessConnectQuoteToolForm) {
      payload.salesManagerCpmsId = _.get(smProfile, 'salesRepId') || null;
    }
  }

  if (formName === businessConnectQuoteToolForm) {
    if (
      businessConnectQuoteToolOrderCategoryName === formData.categoryName &&
      businessConnectQuoteToolForm === formData.formName
    ) {
      const profile = salesRepInfoForSRT || request.getProfile();

      if (profile.channels && profile.channels.length) {
        const { channels } = profile;
        if (payload.channelId) {
          const channelName = channels.find(
            i => Number(i.id) === Number(payload.channelId)
          );
          payload.channelName = channelName && channelName.name;
          payload.channelCode = channelName && channelName.name;
        } else {
          const channelId = channels[0].id;
          payload.channelId = channelId;
          payload.channelStrId = `${channelId}`;
          payload.channelCode = channels[0].name;
        }
      }
      delete profile.id;
      delete profile.province;
      delete profile.status;
      delete profile.createdAt;
      delete profile.updatedAt;

      payload.status = orderStatus.incomplete;
      payload.quoteStatus = quoteStatus.incomplete;
      payload.sendToSRT = false;

      payload = { ...profile, ...payload };
      payload.step = 2;
      payload.assignedToSRT = 0;
      payload.isQuoteReference = false;
      if (['Yes', 'Oui'].includes(payload[fieldSubmittingOnBehalfOf])) {
        payload.submitterName = name;
        payload.submitterEmail = email;
      }
    }
  } else if (formName === orderDetailsForm && step === 7) {
    if (!isSalesSupport) payload.status = orderStatus.pendingValidation;
  }
  if(isMultisiteOrder &&
    step === steps.length - 1 &&
    currentSite !== totalNumberOfMultisites &&
    _.get(orderData, 'status', orderStatusValue.incomplete) !==
    orderStatusValue.waitingOnSales && formData.id){
      const availablePromo = _.get(orderData, 'availableNewpromo', []);
      const { id } = formData;
      payload.availableNewpromo = _.has(payload, 'availableDiscountsAndPromotions')
      ? payload.availableDiscountsAndPromotions 
      : availablePromo;
    return request.put(`/orders/${id}`, payload);
    } if (formData.id) {
    const { id } = formData;
    return request.put(`/orders/${id}`, payload);
  }
  payload.currentSite = 1;
  return request.post('/orders', payload);
}

export default submitPayload;
